/**
 全局变量配置
 */
const isDev = JSON.parse(process.env.VUE_APP_Pattern_Type);
// const publishUrl = "https://bkycms.com/addons/yb_ps/index.php/"; //本地请求测试 http://localhost:8080/
const publishUrl = "http://liecrider.bajiaokeji.cn/index.php";
const apiOrigin = (
  process.env.VUE_APP_API_ORIGIN || publishUrl.replace(/\/index\.php\/?$/i, "")
).replace(/\/$/, "");
const useDevProxy = process.env.VUE_APP_USE_PROXY === "true";

// 开发默认直连 PHP（90），避免请求打到前端端口（8081）导致 404
const backendPath = isDev
  ? useDevProxy
    ? "/index.php/"
    : `${apiOrigin}/index.php/`
  : (location.href.match(/(\S*)views/) || [])[1]
      ? location.href.match(/(\S*)views/)[1] + "index.php/"
      : `${apiOrigin}/index.php/`;
module.exports = {
  // baseURL:  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "preview" ? publishUrl+fwqUrl : location.origin+fwqUrl,
  baseURL: backendPath,
  //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: "管理后台",
  // 路由模式，可选值为 history 或 hash
  routerMode: "hash",
  //不经过token校验的路由
  // routesWhiteList: ["/login", "/register", "/404", "/401"],
  //加载时显示文字
  loadingText: "正在加载中...",
  //配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
  contentType: "application/json;charset=UTF-8",
  //消息框消失时间
  messageDuration: 2000,
  //最长请求时间
  requestTimeout: 60000,
  //操作正常code，支持String、Array两种方式
  successCode: 1,
  //登录失效code
  // invalidCode: 402,
  //无权限code
  // noPermissionCode: 401,
  //是否显示在页面高亮错误
  errorLog: ["development", "test", "production"],
  //是否开启登录拦截
  loginInterception: true,
  //是否开启登录RSA加密
  // loginRSA: false,
  //是否依据mock数据生成webstorm HTTP Request请求文件
  httpRequestFile: false,
  //需要加loading层的请求接口路径阻断，防止重复提交
  debounce: ["doEdit", "del-tel"],
};
